module.exports = __webpack_public_path__ + "static/image/logo-family/logo_font.ver2_0_2.png?5432fd3b";